// @ts-nocheck
import React from 'react';

interface HowItWorksSectionProps {
  sectionId: string;
  sectionData?: any[];
  [key: string]: any;
}

const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({
  sectionId,
  sectionData,
  ...extraProps
}) => {
  return (
    <section id={sectionId} className="container px-4 md:px-6 py-16 lg:py-24">
      <div className="flex w-full flex-col items-center justify-center text-center mb-10">
        <p className="pb-3 font-bold text-destructive text-sm tracking-wide uppercase">Working Process</p>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">
          How it <span className="text-primary underline underline-offset-4">Works</span>
        </h2>
      </div>

      <div className="flex justify-center">
        <img
          src="/how-it-works.png"
          alt="How it works: 1. Plan Your Week, 2. Find Activities, 3. Get Confirmation"
          className="w-full max-w-4xl rounded-2xl box-shadow-float"
        />
      </div>
    </section>
  );
};

export default HowItWorksSection;
